import * as Scrivito from 'scrivito';

Scrivito.provideObjClass('Image', {
  attributes: {
    blob: 'binary',
    alt: 'string',
  },
});
